/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import Sidebar from 'app/components/common/SideBar.jsx';
import { Breakpoint } from 'react-socks';
import ErrorBoundary from 'app/components/common/ErrorBoundary.jsx';
import { Outlet } from 'react-router-dom';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';

class AccountView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            navItems: this.getNavItems(this.props)
        };

        this.getNavItems = this.getNavItems.bind(this);

    }

    componentDidUpdate(prevProps, prevState) {

        if (prevProps.user.hasSubscribed != this.props.user.hasSubscribed || prevProps.user.subscriptionTerm != this.props.user.subscriptionTerm) {
            let navItems = this.getNavItems(this.props);
            this.setState({
                navItems: navItems
            });
        }

    }

    getNavItems(props) {
        let navItems = [],
            accountItem = {
                iconClass: 'fa fa-rocket sidebar-icon',
                label: 'Your Plan',
                labelClass: 'sidebar-label',
                link: '/account/subscription'
            },
            constants = this.props.app.config.constants;

        // deselect the "Account Info" item if we're displaying the pro/agency+ promo
        if (this.props.router.location.pathname.match(/plus/)) {
            accountItem.manualActive = false;
        }

        if (props.user.hasSubscribed && parseInt(props.user.subscriptionTerm, 10) === constants.SUBSCRIPTION_TERM_TRIAL) {
            navItems = [
                {
					iconClass: 'fa fa-user sidebar-icon',
					label: 'Account Info',
					labelClass: 'sidebar-label',
					link: '/account/detail',
                    manualActive: false // this is a hack so the account link doesn't highlight for all items in sidebar
				},
				accountItem
            ];
        } else {
            navItems = [
				{
					iconClass: 'fa fa-user sidebar-icon',
					label: 'Account Info',
					labelClass: 'sidebar-label',
					link: '/account/detail',
                    manualActive: false // this is a hack so the account link doesn't highlight for all items in sidebar
				},
				accountItem,
				{
					iconClass: 'fa fa-credit-card sidebar-icon',
					label: 'Billing Info',
					labelClass: 'sidebar-label',
					link: '/account/billing'
				},
				{
					iconClass: 'fa fa-usd sidebar-icon',
					label: 'Payment History',
					labelClass: 'sidebar-label',
					link: '/account/invoices'
				}
            ];
        }

        return navItems;
    }

	render() {

        let { children, ...otherProps } = this.props;

        if (this.props.router.location.pathname.match(/account$/)) {
            if (this.state.navItems.length) {
                this.state.navItems[0].manualActive = true;
            }
        } else {
            if (this.state.navItems.length) {
                this.state.navItems[0].manualActive = false;
            }
        }

        if (this.props.router.location.pathname.match(/plus$/)) {
            this.state.navItems[1].manualActive = false;
        }

		return (
			<div>
                <ErrorBoundary level="view" {...this.props}>
                    <Breakpoint desktop only>
        				<Sidebar navItems={this.state.navItems} />
                    </Breakpoint>
                    <Outlet context={otherProps}/>
                </ErrorBoundary>
			</div>
		);
	}

};

AccountView.propTypes = {
    defaultPdId: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.number,
        PropTypes.string
    ]),
    defaultSaId: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.number,
        PropTypes.string
    ]),
    recordPath: PropTypes.func,
    getSavedPath: PropTypes.func,
    bannerVisible: PropTypes.bool
};

AccountView.defaultProps = {
    defaultPdId: 0,
    defaultSaId: 0,
    recordPath: null,
    getSavedPath: null,
    bannerVisible: false
};

export default ComponentWithContext(AccountView);
